import { Sort } from '@angular/material/sort';
import { FinalGrade } from 'app/library/final-grade/models/final-grade.model';

export class SetModuleFinalGrades {
    static readonly type = '[ModuleFinalGrades] SetModuleFinalGrades';

    constructor(public payload: FinalGrade[]) {}
}

export class UnsetModuleFinalGrades {
    static readonly type = '[ModuleFinalGrades] UnsetModuleFinalGrades';
}

export class FetchModuleFinalGrades {
    static readonly type = '[ModuleFinalGrades] FetchModuleFinalGrades';

    constructor(
        public payload: {
            moduleId: string;
            search: string;
            sortBy: string;
            sortOrder: string;
            pageSize: number;
            pageNumber: number;
        }
    ) {}
}

export class FetchModuleFinalGradesSuccess {
    static readonly type = '[ModuleFinalGrades] FetchModuleFinalGradesSuccess';
}

export class FetchModuleFinalGradesFailure {
    static readonly type = '[ModuleFinalGrades] FetchModuleFinalGradesFailure';
}

export class FetchModuleFinalGradesForParticipant {
    static readonly type = '[ModuleFinalGrades] FetchModuleFinalGradesForParticipant';

    constructor(
        public payload: {
            moduleId: string;
            participantId: string;
        }
    ) {}
}

export class FetchModuleFinalGradesForParticipantSuccess {
    static readonly type = '[ModuleFinalGrades] FetchModuleFinalGradesForParticipantSuccess';
}

export class FetchModuleFinalGradesForParticipantFailure {
    static readonly type = '[ModuleFinalGrades] FetchModuleFinalGradesForParticipantFailure';
}

export class ToggleSelectedModuleFinalGrade {
    static readonly type = '[ModuleFinalGrades] ToggleSelectedModuleFinalGrade';

    constructor(public payload: string) {}
}

export class SelectFilteredModuleFinalGrades {
    static readonly type = '[ModuleFinalGrades] SelectFilteredModuleFinalGrades';
}

export class DeselectSelectedModuleFinalGrades {
    static readonly type = '[ModuleFinalGrades] DeselectSelectedModuleFinalGrades';
}

export class SearchModuleFinalGrades {
    static readonly type = '[ModuleFinalGrades] SearchModuleFinalGrades';

    constructor(public payload: string) {}
}

export class SortModuleFinalGrades {
    static readonly type = '[ModuleFinalGrades] SortModuleFinalGrades';

    constructor(public payload: Sort) {}
}
